// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevGisController {
	/* @ngInject */
	/**
	 * @param {any} User
	 */
	constructor(User) {
		this.item = { kid: 'K_NODE;xxx' };
		this.key = User.getAppConfig().GOOGLE.key;
	}
}
